function EmergencyCard({ type, title, number, onCall }) {
    const icons = {
        police: '👮',
        ambulance: '🚑',
        fire: '🚒'
    }

    const actions = [
        { label: 'LOCATION' },
        { label: 'DETAILS' }
    ]

    return (
        <div className={`emergency-card ${type}`} onClick={onCall}>
            <div className="emergency-card-header">
                <div className="emergency-card-icon">
                    <span>{icons[type]}</span>
                </div>
                <div>
                    <h3 className="emergency-card-title">{title}</h3>
                    <p className="emergency-card-number">
                        {number}
                    </p>
                </div>
            </div>

            <div className="emergency-card-actions">
                {actions.map((action, index) => (
                    <button
                        key={index}
                        className="emergency-action-btn"
                        onClick={(e) => {
                            e.stopPropagation()
                            console.log(`${action.label} action for ${title}`)
                        }}
                    >
                        {/* <span className="icon">{action.icon}</span> */}
                        <span>{action.label}</span>
                    </button>
                ))}
            </div>

            <div className="emergency-card-actions" style={{ marginTop: '0.5rem' }}>
                <button
                    className="emergency-action-btn"
                    onClick={(e) => {
                        e.stopPropagation()
                        window.location.href = `tel:${number}`
                    }}
                    style={{ gridColumn: 'span 2' }}
                >
                    {/* <span className="icon">📤</span> */}
                    <span>FWD {number}</span>
                </button>
            </div>
        </div>
    )
}

export default EmergencyCard
